const HOSTS = new Set(['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtu.be', 'www.youtu.be', 'youtube-nocookie.com', 'www.youtube-nocookie.com']);

function parseYoutubeUrl(value) {
  if (typeof value !== 'string' || value.length > 2048) return null;
  try {
    const url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(value.trim()) ? value.trim() : `https://${value.trim()}`);
    if (!['https:', 'http:'].includes(url.protocol) || !HOSTS.has(url.hostname) || url.username || url.password || url.port) return null;
    const parts = url.pathname.split('/').filter(Boolean);
    const id = url.hostname.endsWith('youtu.be') ? (parts.length === 1 ? parts[0] : null) : url.pathname === '/watch' ? url.searchParams.get('v') : ['embed', 'shorts', 'live'].includes(parts[0]) && parts.length === 2 ? parts[1] : null;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return null;
    const stamp = url.searchParams.get('t') || url.searchParams.get('start') || '';
    const time = stamp.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
    const seconds = /^\d+$/.test(stamp) ? Number(stamp) : time ? Number(time[1] || 0) * 3600 + Number(time[2] || 0) * 60 + Number(time[3] || 0) : 0;
    const start = Number.isSafeInteger(seconds) ? Math.max(0, Math.min(86400, seconds)) : 0;
    return { id, start, url: `https://www.youtube.com/watch?v=${id}${start ? `&t=${start}s` : ''}` };
  } catch {
    return null;
  }
}

module.exports = { parseYoutubeUrl };
